export default __webpack_public_path__ + "static/media/quickshop_badge.4515a98a.png";